import { SocialMediaType } from "@components/Button/utils/types";
import { IconTypeEnum } from "@components/Icon/utils/types";

export const SHARE_LINKS_LIST = [
  {
    whichSocialMedia: SocialMediaType.facebook,
    icon: IconTypeEnum.facebook,
    gaEventLabel: "facebook",
  },
  {
    whichSocialMedia: SocialMediaType.linkedin,
    icon: IconTypeEnum.linkedin,
    gaEventLabel: "linkedin",
  },
  {
    whichSocialMedia: SocialMediaType.twitter,
    icon: IconTypeEnum.twitter,
    gaEventLabel: "twitter",
  },
  {
    whichSocialMedia: SocialMediaType.telegram,
    icon: IconTypeEnum.telegram,
    gaEventLabel: "telegram",
  },
];
